import axios from 'axios';
import storage from "../utils/storage";

const request = () => {
  if (!!storage.userToken.get()) {
    return axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: { Authorization: "bearer " + storage.userToken.get() },
    });
  }
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL
  });
};

export default request
